import { render, staticRenderFns } from "./MedicalCare.vue?vue&type=template&id=36493392"
import script from "./MedicalCare.vue?vue&type=script&lang=js"
export * from "./MedicalCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports